import React from 'react';
import classes from "./UtilitiesLists.module.css";
import one from "../../asstets/imgs/one.webp";
import two from "../../asstets/imgs/two.webp";
import three from "../../asstets/imgs/three.webp";

export default function UtilitiesLists() {
    return (
        <div className={classes.UtilitiesLists}>
            <div className={classes.item}>
                <div className={classes.Title}>
                    <img src={one} alt="img-one" />
                </div>
                <div className={classes.description}>
                    <p>
                        Two or more holders connect on our platform
                    </p>
                </div>
                <div className={classes.frame}>
                    <svg width="89" height="92" viewBox="0 0 89 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M62.2798 76.7585C47.6781 83.3366 29.3013 74.1525 21.2341 56.2453C13.1669 38.338 18.4641 18.4888 33.0657 11.9107C47.6674 5.33259 66.0442 14.5167 74.1114 32.4239C82.1787 50.3311 76.8815 70.1804 62.2798 76.7585Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M33.0659 11.9106L26.4389 14.8961C11.8358 21.4749 6.53969 41.3228 14.6043 59.2242C22.6689 77.1256 41.0439 86.3097 55.6448 79.7319L62.2741 76.7454" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M30.5688 17.9346C28.6345 19.0782 25.7119 22.9286 24.0893 27.1135C22.3402 31.6249 21.58 36.5791 21.9333 39.2438" stroke="white" strokeWidth="3" strokeLinecap="round" />
                        <path d="M51.2881 27.0134L54.3925 42.94" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M35.7312 32.1538L40.4392 45.1863" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M47.9615 51.7528C50.9614 55.3143 55.0742 55.3647 59.1929 55.0717C55.7438 57.117 52.9409 59.9608 51.0104 63.5441" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
            </div>
            <div className={`${classes.item} ${classes.second}`}>
                <div className={classes.Title}>
                    <img src={two} alt="img-one" />
                </div>
                <div className={classes.description}>
                    <p>
                        A team of holders can buy NFTs and sell them using a common wallet. The profit or loss amount will be paid back to the wallet according to the contribution made.
                    </p>
                </div>
            </div>
            <div className={`${classes.item} ${classes.thrid}`}>
                <div className={classes.Title}>
                    <img src={three} alt="img-one" />
                </div>
                <div className={classes.description}>
                    <p>
                        Also, all holders will have a shared wallet where the money of the secondary market and 30% of the project's revenue will be stored. Using this wallet, we will make transactions all together, distributing the profit among all holders.
                    </p>
                </div>
            </div>
        </div>
    )
}
